import { Country } from "country-state-city";
import { Form, Select } from "antd";
import { useEffect, useState } from "react";

const createOptions = (list: any[]) => {
  return list.map((item) => {
    return {
      value: item.isoCode,
      label: item.name,
    };
  });
};

function CountrySelect({ onChange }: { onChange?: (value: string) => void }) {
  const [countryOptions, setCountryOptions] = useState<any>([]);

  let listAllCountries = Country.getAllCountries();

  useEffect(() => {
    let options = createOptions(listAllCountries);
    setCountryOptions(options);
  }, []);

  const handleSearchCountry = (value: string) => {
    let filtered = listAllCountries.filter((country) => {
      return country.name
        .toLowerCase()
        .trim()
        .includes(value.toLowerCase().trim());
    });

    let options = createOptions(filtered);
    setCountryOptions(options);
  };
  return (
    <Form.Item
      name="country"
      label="País"
      rules={[{ required: true, message: "País es requerido" }]}
    >
      <Select
        placeholder={"País"}
        options={countryOptions}
        onSearch={handleSearchCountry}
        onChange={onChange}
        showSearch
        filterOption={false}
        allowClear
      />
    </Form.Item>
  );
}

export default CountrySelect;
